import {gql} from 'apollo-angular';


export const SEND_RESET_EMAIL = gql`
  query forgotPassword($email: String!) {
    forgotPassword(email: $email) {
      success
      message
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword(
    $password: String!
    $confirmPassword: String!
    $token: String!
  ) {
    resetPassword(
      password: $password
      confirmPassword: $confirmPassword
      token: $token
    ) {
      message
      success
    }
  }
`;
